import { AdHandlerConfig, AdUnitProvidersConfig } from '@/modules/adv'
import { BannerSequenceConfig } from '@/modules/adv/banner-sequence-config'
import { MINIPLAY_CLID } from '@/modules/main-frame/custom-integrations/miniplay'
import { XIAOMI_TEST_CLID } from '@/modules/main-frame/custom-integrations/xiaomi'
import { AdProviderNames } from '@/types'

export type Config = {
    isInitGameScreenHidden?: boolean
    isPreloaderDisabled?: boolean
    isDebranding?: boolean
    isPrerollDisabled?: boolean
    bannerSequenceConfig?: BannerSequenceConfig
    inGameAdUnitProviderConfig?: Partial<AdUnitProvidersConfig<AdProviderNames>> | undefined
    inGameAdHandlerConfig?: Partial<AdHandlerConfig> | undefined
    inGameProviderKeys?: AdProviderNames[] | undefined
}

const GAME_16_CLID = 'p_a48fc4e4-2388-4403-a1b9-fce2b19a1f97'
const Y8_CLID = 'p_d1847169-9b0a-4ac8-a722-3ad587f8841c'
const PLAY_GAMES_CLID = 'p_ae5af802-1a10-4cc0-9e2a-989216d478af'
const SPIElE_CLID = '5496748'

const CONFIG: Record<string, Config> = {
    [MINIPLAY_CLID]: {
        isInitGameScreenHidden: true,
        inGameAdUnitProviderConfig: {
            [AdProviderNames.GOOGLE_INSTREAM_CHEAP]: {
                desktop: {
                    interstitial_preroll: 'instream_preroll_no_floor_desktop',
                    interstitial: 'instream_no_floor_desktop',
                    rewarded: 'instream_rewarded_no_floor_desktop',
                },
                mobile: {
                    interstitial_preroll: 'instream_preroll_no_floor_mobile',
                    interstitial: 'instream_no_floor_mobile',
                    rewarded: 'instream_rewarded_no_floor_mobile',
                },
            },
        },
        inGameProviderKeys: [AdProviderNames.GOOGLE_INSTREAM, AdProviderNames.GOOGLE_INSTREAM_CHEAP],
    },
    lagged: {
        isInitGameScreenHidden: true,
        isPreloaderDisabled: true,
        isDebranding: true,
        isPrerollDisabled: true,
    },
    [PLAY_GAMES_CLID]: {
        inGameAdHandlerConfig: {
            interstitial: {
                timeout: 180_000,
            },
        },
    },
    [Y8_CLID]: {
        isPreloaderDisabled: true,
        isPrerollDisabled: true,
        isInitGameScreenHidden: true,
        inGameAdHandlerConfig: {
            interstitial: {
                timeout: 180_000,
            },
        },
    },
    [GAME_16_CLID]: {
        bannerSequenceConfig: {},
        inGameAdHandlerConfig: {
            interstitial: {
                timeout: 180_000,
            },
        },
    },
    [SPIElE_CLID]: {
        inGameAdHandlerConfig: {
            interstitial: {
                timeout: 180_000,
            },
        },
    },
    [XIAOMI_TEST_CLID]: {
        isInitGameScreenHidden: true,
        isPrerollDisabled: true,
    },
}

export function getConfigByClid(clid: string): Config {
    return CONFIG[clid] || {}
}
